var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReserveV2 = function SvgReserveV2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.3 4.8v.4h7.195v11h-11v-11H7.5V4h5v1.2h-.8v-.4H8.3ZM14.695 6h-9.4v9.4h9.4V6ZM7 9.2h6v-.8H7v.8Zm5 2H7v-.8h5v.8Zm-5 2h5.5v-.8H7v.8Z",
    fill: "currentColor"
  })));
};
export default SvgReserveV2;